import getApi from '../../api'

export const getMailSubject = (documentIds: number[]) =>
  getApi().post<{ subject: string }>('/mss/subject', { documentIds })
